import React, { useCallback } from 'react';
import { View } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { AppView, CollapsableContainer } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { extractKeyFromKey } from 'utils/flatListHelpers';
import { emptyArray, isWeb } from '../../../constants';
import Li from '../components/Li';
import { selectPotProductFromProductId } from '../reducers/selectors';
const InterestPotsFAQsScreen = withAnimatedNavigationHeader(({ scrollY, route }) => {
    const styles = useStyles(styleSet);
    const interestProduct = useAppSelector((store) => selectPotProductFromProductId(store, route.params.productId));
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    const renderItem = useCallback(({ item }) => (<CollapsableContainer title={item.title} style={styles.collapsible} isCollapsedByDefault={false}>
          <View style={styles.infoContainer}>
            <Text TextThin-14 Secondary>
              {item.desc}
            </Text>
          </View>
          {!!item.li?.length && (<View style={styles.liContainer}>
              {item.li.map((desc) => (<Li key={desc} desc={desc}/>))}
            </View>)}
        </CollapsableContainer>), [styles.collapsible, styles.infoContainer, styles.liContainer]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    return (<AppView type="secondary" withFrame={false}>
        <StatusBar animated barStyle="dark-content"/>
        <Animated.FlatList renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} data={interestProduct?.faqList || emptyArray} keyExtractor={extractKeyFromKey('title')} contentContainerStyle={paddingBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Key information',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styleSet = createStyleSheets(() => ({
    collapsible: {
        marginTop: rem(16),
        marginHorizontal: rem(16),
    },
    infoContainer: {
        padding: rem(16),
    },
    liContainer: {
        paddingVertical: rem(12),
        paddingHorizontal: rem(16),
    },
}));
export default InterestPotsFAQsScreen;
